<template>
    <div class="mt-3 p-4">
        <div class="relative">
            <button
                type="button"
                @click="submit"
                class="flex mx-auto -mt-11 pl-5 text-white storefront-btn-blue font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mt-2dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                :disabled="formData.primaryEmail == ''"
            >
                <svg-vue
                    v-if="isSavingContactInfo"
                    icon="loader"
                    title="Loading"
                />
                Save
            </button>
        </div>
        <div>
            <Location
                locationType="Home"
                :location="formData.home_location"
            />
            <div v-if="lat != null && lng != null">
                <Leaflet
                    ref="map"
                    :lat="parseFloat(lat)"
                    :lng="parseFloat(lng)"
                    :zoom=16
                    :width=scrollWidth
                    :height="parseInt(300)"
                />
            </div>
        </div>

        <div>
            <h3 class="">Phone Number</h3>
            <input
                type="text"
                v-model="formData.phones.primaryNum.value"
                v-mask="'(###) ###-####'"
                class="flex-row-reverse w-2/3 h-9 ml-26 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                placeholder="SMS Notification Number"
                required
            />
            <div class="flex-col ml-28">
                <input
                    type="text"
                    v-model="formData.phones.secondNum.value"
                    v-mask="'(###) ###-####'"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary Phone Number "
                />
                <input
                    type="text"
                    v-model="formData.phones.thirdNum.value"
                    v-mask="'(###) ###-####'"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary Phone Number"
                />
                <input
                    type="text"
                    v-model="formData.phones.fourthNum.value"
                    v-mask="'(###) ###-####'"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary Phone Number"
                />
            </div>
        </div>
        <div class="mt-3">
            <h3>Email</h3>
            <input
                type="text"
                v-model="formData.emails.primaryEmail.value"
                class="flex w-2/3 h-9 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                placeholder="Primary Email"
                required
            />
            <div class="flex-col ml-28">
                <input
                    type="text"
                    v-model="formData.emails.secondaryEmail.value"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary email"
                />
                <input
                    type="text"
                    v-model="formData.emails.thirdEmail.value"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary email"
                />
                <input
                    type="text"
                    v-model="formData.emails.fourthEmail.value"
                    class="w-full mt-3 h-9 ml-2 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5 dark:border-gray-400 dark:placeholder-gray-400 dark:text-black dark:focus:border-gray-300"
                    placeholder="Secondary email"
                />
            </div>
        </div>
    </div>
</template>
<script>
import {VueMaskDirective} from "v-mask";
import Leaflet from "../../Location/Leaflet.vue";
import HoursPanel from "./HoursPanel.vue";
import Location from "../../Location/Index.vue";

export default {
    components: {Location, Leaflet, HoursPanel},
    props: ["user"],
    data() {
        return {
            scrollWidth: this.scrollWidth,
            formData: {
                business_location: {
                    address1: this.user.business_location && this.user.business_location.address1
                        ? this.user.business_location.address1
                        : '',
                    address2: this.user.business_location && this.user.business_location.address2
                        ? this.user.business_location.address2
                        : '',
                    city: this.user.business_location && this.user.business_location.city
                        ? this.user.business_location.city
                        : '',
                    state_province: this.user.business_location && this.user.business_location.state_province
                        ? this.user.business_location.state_province
                        : '',
                    postal_code: this.user.business_location && this.user.business_location.postal_code
                        ? this.user.business_location.postal_code
                        : ''
                },
                home_location: {
                    address1: this.user.home_location && this.user.home_location.address1
                        ? this.user.home_location.address1
                        : '',
                    address2: this.user.home_location && this.user.home_location.address2
                        ? this.user.home_location.address2
                        : '',
                    city: this.user.home_location && this.user.home_location.city
                        ? this.user.home_location.city
                        : '',
                    state_province: this.user.home_location && this.user.home_location.state_province
                        ? this.user.home_location.state_province
                        : '',
                    postal_code: this.user.home_location && this.user.home_location.postal_code
                        ? this.user.home_location.postal_code
                        : ''
                },
                phones: {
                    primaryNum: {
                        value: this.user.phones[0]
                            ? this.user.phones[0].value
                            : "",
                        label: "primary",
                    },
                    secondNum: {
                        value: this.user.phones[1]
                            ? this.user.phones[1].value
                            : "",
                        label: "secondary",
                    },
                    thirdNum: {
                        value: this.user.phones[2]
                            ? this.user.phones[2].value
                            : "",
                        label: "secondary",
                    },
                    fourthNum: {
                        value: this.user.phones[3]
                            ? this.user.phones[3].value
                            : "",
                        label: "secondary",
                    },
                },
                emails: {
                    primaryEmail: {
                        value: this.user.primary_email.value,
                        label: "primary",
                    },
                    secondaryEmail: {
                        value: '',
                        label: "secondary",
                    },
                    thirdEmail: {
                        value: '',
                        label: "secondary",
                    },
                    fourthEmail: {
                        value: '',
                        label: "secondary",
                    },
                },
            },
            lat: this.user.home_location == null ? null : this.user.home_location.lat,
            lng: this.user.home_location == null ? null : this.user.home_location.lng,
            isSavingContactInfo: false,
        };
    },
    methods: {
        async submit() {
            this.isSavingContactInfo = true;
            console.log( this.formData);
            console.log( this.formData.home_location);
            await axios
                .post("/api/settings/contactInfo", {
                    name: this.formData.name,
                    phones: this.parsePhonesForAPICall(),
                    emails: this.formData.emails,
                    business_location: this.formData.business_location,
                    home_location: this.formData.home_location
                })
                .then((response) => {
                    this.isSavingContactInfo = false;
                    window.location.reload(true);
                    this.$toasted.global.toast_success('Save Successful');
                })
                .then(
                    await axios
                        .get(`/api/user/${this.user.id}`)
                        .then((response) => {
                            this.lat = response.data.home_location.lat;
                            this.lng = response.data.home_location.lng;
                        })
                )
                .catch((error) => {
                    console.log(error);
                    alert("something went wrong!");
                });
        },
        parsePhonesForAPICall() {
            let arr = [];
            Object.keys(this.formData.phones).forEach((key) => {
                if (this.formData.phones[key].value) {
                    arr.push(this.formData.phones[key]);
                }
            });
            return arr;
        },
    },
    mounted() {

        // fill in email values except the one marked as primary
        let emailsCopy = JSON.parse(JSON.stringify(this.user.emails));
        Object.keys(this.formData.emails).forEach((key) => {
            if (key == 'primaryEmail') return;
            if (emailsCopy[0]?.value == this.user.primary_email.value) {
                emailsCopy.splice(0, 1);
            }
            if (emailsCopy.length) {
                this.formData.emails[key].value = emailsCopy[0].value;
                emailsCopy.splice(0, 1);
            }
        });
        console.log( 'home location');
        console.log( this.user.home_location);
    },
    directives: {
        mask: VueMaskDirective,
    }
};
</script>
